import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileZip: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-zip"><path d="M8.75 19V17.5M10.25 17.5V16M8.75 16V14.5M10.25 20.5V19M10.25 14.5V13M8.75 13V11.5M13.25 3.10598V8.75H19M4.75 2.75V21.25H19.25V8.25L13.75 2.75H4.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFileZip;
